import { socket } from '../core/socket.js';
import { t } from '../core/i18n.js';
import { popToast } from '../utils/alerts.js';

// --- LES COOKIES DE SESSION ---

export function getCookie(name) {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

// --- INSCRIPTION ---

export function procederInscription() {
    const pseudo = document.getElementById('reg-pseudo').value.trim();
    const email = document.getElementById('reg-email').value.trim();
    const pass = document.getElementById('reg-password').value;
    const confirm = document.getElementById('reg-confirm').value;
    const errorEl = document.getElementById('auth-error');

    if (pseudo.length < 3) return errorEl.textContent = t('validate.pseudo_short');
    if (!email || !email.includes('@')) return errorEl.textContent = t('validate.email_invalid');
    if (pass.length < 8) return errorEl.textContent = t('validate.password_short');
    if (pass !== confirm) return errorEl.textContent = t('validate.password_mismatch');

    socket.emit('inscription', { pseudo, email, password: pass });
}

// --- CONNEXION / DÉCONNEXION ---

export function connexion() {
    const pseudo = document.getElementById('login-pseudo').value;
    const password = document.getElementById('login-password').value;
    const errEl = document.getElementById('auth-error');
    if (errEl) { errEl.textContent = ''; errEl.classList.remove('auth-error-shake'); }
    if (pseudo && password) {
        socket.emit('connexion', { pseudo, password });
    } else { popToast(t('validate.login_empty'), 'error'); }
}

export function deconnexion() {
    localStorage.removeItem('chaos_token');
    localStorage.removeItem('monChatPseudo');
    sessionStorage.removeItem('chaos_session_active');
    localStorage.removeItem('memoireVocalId');
    localStorage.removeItem('memoireVocalNom');

    if (socket) socket.disconnect();

    if (typeof window.naviguer === "function") {
        window.naviguer('login');
    } else {
        window.location.reload();
    }
}

// Touche Entrée sur le formulaire de connexion
const ecouterEntree = (event) => { if (event.key === "Enter") connexion(); };
const inputP = document.getElementById('login-pseudo');
const inputM = document.getElementById('login-password');
if (inputP) inputP.addEventListener("keypress", ecouterEntree);
if (inputM) inputM.addEventListener("keypress", ecouterEntree);

// --- GOOGLE OAUTH : CHOIX DU PSEUDO ---

export async function validerSetupGoogle() {
    const pseudo = document.getElementById('google-setup-pseudo').value.trim();
    const errEl = document.getElementById('google-setup-error');

    if (!/^[a-zA-Z0-9_]{3,20}$/.test(pseudo)) {
        errEl.textContent = t('auth.google_setup.invalid') || 'Pseudo invalide (3–20 caractères, lettres/chiffres/_).';
        return;
    }
    errEl.textContent = '…';

    const res = await fetch('/api/google-setup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ setupToken: window._googleSetupToken, pseudo })
    });
    const data = await res.json();

    if (data.success) {
        errEl.style.color = '#3fb950';
        errEl.textContent = '✅ Compte créé !';
        localStorage.setItem('chaos_token', data.token);
        window._googleSetupToken = null;
        setTimeout(() => socket.emit('valider-session', data.token), 400);
    } else {
        errEl.style.color = '#f85149';
        errEl.textContent = data.error || 'Erreur inconnue.';
    }
}

// --- RESET MOT DE PASSE ---

export function ouvrirModalReset() {
    document.getElementById('modal-reset-pass').style.display = 'flex';
    document.getElementById('reset-msg-retour').innerText = "";
}

export function fermerModalReset() {
    document.getElementById('modal-reset-pass').style.display = 'none';
    document.getElementById('reset-pseudo').value = '';
    document.getElementById('reset-msg-retour').textContent = '';
}

export function validerResetPass() {
    const pseudo = document.getElementById('reset-pseudo').value.trim();
    const msgRetour = document.getElementById('reset-msg-retour');

    if (!pseudo) {
        msgRetour.style.color = '#f85149';
        msgRetour.textContent = 'Entre ton pseudo.';
        return;
    }

    msgRetour.style.color = '#8b949e';
    msgRetour.textContent = 'Envoi en cours…';
    socket.emit('demande-reset-mdp', { pseudo });
}

socket.on('reset-mdp-envoye', () => {
    const msgRetour = document.getElementById('reset-msg-retour');
    msgRetour.style.color = '#3fb950';
    msgRetour.textContent = '✅ Si ce compte existe, un lien de récupération a été envoyé à l\'adresse e-mail associée.';
    document.getElementById('reset-pseudo').value = '';
});

// --- RETOURS SERVEUR SUR L'AUTH ---

socket.on('verification-email-sent', ({ email }) => {
    const display = document.getElementById('verify-email-display');
    if (display) display.textContent = email;
    window.naviguer('verify');
    const errorP = document.getElementById('auth-error');
    if (errorP) errorP.textContent = '';
});

socket.on('inscription-error', (message) => {
    const errorP = document.getElementById('auth-error');
    errorP.style.color = "#f85149";
    errorP.textContent = message;
});

// Échec d'authentification. { code } générique (anti-énumération de comptes).
socket.on('connexion-error', (payload) => {
    if (window._finBoot) window._finBoot();
    const code = (payload && typeof payload === 'object') ? payload.code : null;
    let msg;
    if (code === 'BAD_CREDENTIALS') msg = "Tu as oublié comment t'identifier, Agent ? 🔐";
    else if (code === 'SERVER_ERROR') msg = "Le Chaos vacille... réessaie dans un instant, Agent.";
    else msg = (typeof payload === 'string' && payload) ? payload : "Connexion impossible, Agent.";

    const errorP = document.getElementById('auth-error');
    if (!errorP) return;
    errorP.style.color = "#f85149";
    errorP.textContent = msg;
    errorP.classList.remove('auth-error-shake');
    void errorP.offsetWidth; // reflow → rejoue l'animation CSS
    errorP.classList.add('auth-error-shake');
});

// ==========================================================================
//   DOUBLE AUTHENTIFICATION (2FA / TOTP)
// ==========================================================================

let _pending2faToken = null;

socket.on('connexion-2fa-requis', ({ pendingToken }) => {
    _pending2faToken = pendingToken;
    document.getElementById('modal-2fa-login').style.display = 'flex';
    document.getElementById('input-2fa-login').value = '';
    document.getElementById('msg-2fa-login').textContent = '';
    setTimeout(() => document.getElementById('input-2fa-login').focus(), 100);
});

export function valider2FALogin() {
    const code = document.getElementById('input-2fa-login').value.trim();
    const msg  = document.getElementById('msg-2fa-login');
    if (!code) { msg.textContent = 'Entre un code.'; return; }
    msg.style.color = '#8b949e'; msg.textContent = 'Vérification…';
    socket.emit('connexion-2fa-verif', { pendingToken: _pending2faToken, code });
}

export function annuler2FALogin() {
    _pending2faToken = null;
    document.getElementById('modal-2fa-login').style.display = 'none';
}

socket.on('connexion-2fa-erreur', (msg) => {
    const el = document.getElementById('msg-2fa-login');
    el.style.color = '#f85149'; el.textContent = msg;
});

export function majUI2FA(enabled) {
    const on  = document.getElementById('totp-section-on');
    const off = document.getElementById('totp-section-off');
    if (on)  on.style.display  = enabled ? '' : 'none';
    if (off) off.style.display = enabled ? 'none' : '';
}

export async function lancer2FASetup() {
    document.getElementById('modal-2fa-setup').style.display = 'flex';
    document.getElementById('step-2fa-qr').style.display = '';
    document.getElementById('step-2fa-backup').style.display = 'none';
    document.getElementById('input-2fa-setup').value = '';
    document.getElementById('msg-2fa-setup').textContent = '';
    document.getElementById('div-2fa-qrcode').innerHTML = '<span style="color:#8b949e;font-size:.85em;">Génération…</span>';
    socket.emit('2fa-generer');
}

socket.on('2fa-secret', async ({ base32, otpauth_url }) => {
    document.getElementById('span-2fa-secret').textContent = base32;
    if (!window.QRCode) {
        await new Promise((res, rej) => {
            const s = document.createElement('script');
            s.src = '/crypto/vendor/qrcode.min.js';
            s.onload = res; s.onerror = rej;
            document.head.appendChild(s);
        });
    }
    const canvas = document.createElement('canvas');
    document.getElementById('div-2fa-qrcode').innerHTML = '';
    document.getElementById('div-2fa-qrcode').appendChild(canvas);
    QRCode.toCanvas(canvas, otpauth_url, { width: 200, color: { dark: '#c9d1d9', light: '#0d1117' } });
});

export function confirmer2FASetup() {
    const code = document.getElementById('input-2fa-setup').value.trim();
    const msg  = document.getElementById('msg-2fa-setup');
    if (code.length < 6) { msg.style.color='#f85149'; msg.textContent='Code à 6 chiffres requis.'; return; }
    msg.style.color='#8b949e'; msg.textContent='Vérification…';
    socket.emit('2fa-activer', { code });
}

let _backupCodes = [];

socket.on('2fa-active', ({ backupCodes }) => {
    _backupCodes = backupCodes;
    document.getElementById('step-2fa-qr').style.display = 'none';
    document.getElementById('step-2fa-backup').style.display = '';
    const div = document.getElementById('div-backup-codes');
    div.innerHTML = backupCodes.map(c =>
        `<span style="color:var(--theme-primary); padding:2px 0;">${c}</span>`
    ).join('');
    majUI2FA(true);
});

export function copierCodesSecours() {
    navigator.clipboard.writeText(_backupCodes.join('\n'))
        .then(() => popToast('Codes copiés !', 'success'))
        .catch(() => popToast('Copie impossible, note-les manuellement.', 'error'));
}

export function fermer2FASetup() {
    document.getElementById('modal-2fa-setup').style.display = 'none';
    _backupCodes = [];
}

socket.on('2fa-erreur', (msg) => {
    const elSetup   = document.getElementById('msg-2fa-setup');
    const elDisable = document.getElementById('msg-2fa-disable');
    if (elSetup   && document.getElementById('modal-2fa-setup').style.display !== 'none')   { elSetup.style.color='#f85149';   elSetup.textContent=msg;   }
    if (elDisable && document.getElementById('modal-2fa-disable').style.display !== 'none') { elDisable.style.color='#f85149'; elDisable.textContent=msg; }
});

export function ouvrirDesactiver2FA() {
    document.getElementById('modal-2fa-disable').style.display = 'flex';
    document.getElementById('input-2fa-disable').value = '';
    document.getElementById('msg-2fa-disable').textContent = '';
}

export function confirmerDesactiver2FA() {
    const code = document.getElementById('input-2fa-disable').value.trim();
    const msg  = document.getElementById('msg-2fa-disable');
    if (!code) { msg.style.color='#f85149'; msg.textContent='Entre ton code TOTP.'; return; }
    msg.style.color='#8b949e'; msg.textContent='Vérification…';
    socket.emit('2fa-desactiver', { code });
}

socket.on('2fa-desactive', () => {
    document.getElementById('modal-2fa-disable').style.display = 'none';
    majUI2FA(false);
    popToast('Double authentification désactivée.', 'success');
});

// --- CAROUSEL DE PRÉSENTATION ---
// Les phrases sont dans des <li data-i18n> traduits par i18n.apply().
// On attend l'event 'i18n:ready' pour s'assurer que le fetch JSON est fini.

let _carouselTimer = null;

function initAuthCarousel() {
    const el   = document.getElementById('auth-carousel-text');
    const list = document.getElementById('auth-carousel-phrases');
    if (!el || !list) return;

    // Annule un éventuel carousel précédent (changement de langue)
    if (_carouselTimer) { clearInterval(_carouselTimer); _carouselTimer = null; }

    const getPhrases = () =>
        Array.from(list.querySelectorAll('li'))
             .map(li => li.textContent.trim())
             .filter(Boolean);

    let idx = 0;

    function next() {
        const phrases = getPhrases();
        if (!phrases.length) return;

        el.classList.remove('carousel-in');
        el.classList.add('carousel-out');
        setTimeout(() => {
            el.textContent = phrases[idx % phrases.length];
            idx++;
            el.classList.remove('carousel-out');
            void el.offsetWidth; // force reflow pour relancer l'animation CSS
            el.classList.add('carousel-in');
        }, 540);
    }

    next();
    _carouselTimer = setInterval(next, 3800);
}

// Démarre après chaque chargement/changement de langue
document.addEventListener('i18n:ready', initAuthCarousel);

// --- INVITATION PAR LIEN (?invite=CODE) ---
// Lu au chargement (avant l'auth), stocké en session le temps que l'agent se
// connecte/s'inscrive, puis consommé après la connexion réussie.

function _lireInviteDepuisURL() {
    try {
        const code = new URLSearchParams(location.search).get('invite');
        if (code && code.trim()) {
            sessionStorage.setItem('chaos_invite_attente', code.trim());
            history.replaceState(null, '', location.origin + location.pathname + location.hash);
        }
    } catch (_) {}
}
_lireInviteDepuisURL();

export function consommerInviteEnAttente() {
    let code = null;
    try { code = sessionStorage.getItem('chaos_invite_attente'); } catch (_) {}
    if (!code) return;
    try { sessionStorage.removeItem('chaos_invite_attente'); } catch (_) {}
    socket.emit('rejoindre-via-code', code);
    popToast("🎫 Lien d'invitation détecté — accès à la sphère…");
}
